import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { breakpoints } from '@openedx/paragon';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { useLocation } from 'react-router-dom';

import {
  ImageExtraSmallLayout, ImageLargeLayout, ImageMediumLayout, ImageSmallLayout,
} from './components/image-layout';
import { AuthLargeLayout, AuthMediumLayout, AuthSmallLayout } from './components/welcome-page-layout';
import imgLogin from './img/img-login.png';
import imgRegister from './img/img-register.png';
import logoEduvence from './img/svg-eduvence-logo.svg';

const BaseContainer = ({ children, showWelcomeBanner, fullName }) => {
  const enableImageLayout = getConfig().ENABLE_IMAGE_LAYOUT;
  const location = useLocation();

  if (enableImageLayout) {
    return (
      <div className="layout">
        <MediaQuery maxWidth={breakpoints.extraSmall.maxWidth - 1}>
          {showWelcomeBanner ? <AuthSmallLayout fullName={fullName} /> : <ImageExtraSmallLayout />}
        </MediaQuery>
        <MediaQuery minWidth={breakpoints.small.minWidth} maxWidth={breakpoints.small.maxWidth - 1}>
          {showWelcomeBanner ? <AuthSmallLayout fullName={fullName} /> : <ImageSmallLayout />}
        </MediaQuery>
        <MediaQuery minWidth={breakpoints.medium.minWidth} maxWidth={breakpoints.large.maxWidth - 1}>
          {showWelcomeBanner ? <AuthMediumLayout fullName={fullName} /> : <ImageMediumLayout />}
        </MediaQuery>
        <MediaQuery minWidth={breakpoints.extraLarge.minWidth}>
          {showWelcomeBanner ? <AuthLargeLayout fullName={fullName} /> : <ImageLargeLayout />}
        </MediaQuery>
        <div className={classNames('content', { 'align-items-center mt-0': showWelcomeBanner })}>
          {children}
        </div>
      </div>
    );
  }

  if (showWelcomeBanner) {
    return (
      <>
        <div className="col-md-12 extra-large-screen-top-stripe" />
        <div className="layout">
          <MediaQuery maxWidth={breakpoints.small.maxWidth - 1}>
            <AuthSmallLayout fullName={fullName} />
          </MediaQuery>
          <MediaQuery minWidth={breakpoints.medium.minWidth} maxWidth={breakpoints.large.maxWidth - 1}>
            <AuthMediumLayout fullName={fullName} />
          </MediaQuery>
          <MediaQuery minWidth={breakpoints.extraLarge.minWidth}>
            <AuthLargeLayout fullName={fullName} />
          </MediaQuery>
          <div className="content align-items-center mt-0">
            {children}
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="layout authn-container">
        <div className="content">
          {children}
        </div>
        <div className="layout-image">
          {location.pathname === '/login' ? <img src={imgLogin} alt="" /> : <img src={imgRegister} alt="" />}
        </div>
      </div>
      <div className="eduvence-logo-container">
        <a href="https://eduvence.com/">
          <img src={logoEduvence} alt="" />
        </a>
      </div>
    </>
  );
};

BaseContainer.defaultProps = {
  showWelcomeBanner: false,
  fullName: null,
};

BaseContainer.propTypes = {
  children: PropTypes.node.isRequired,
  showWelcomeBanner: PropTypes.bool,
  fullName: PropTypes.string,
};

export default BaseContainer;
